import SwitchToggle from "../Layout/MiniDisplays/SwitchToggle";
import { Link } from "react-router-dom";
import { betaFeaturesListings } from "../../Data/BetaFeatures";
import { useAuth } from "../../contexts/AuthContext";
import { useSettings } from "../../contexts/SettingsContext";
import { useEffect } from "react";
import { useState } from "react";

export const BetaFeaturesSection = () => {
  const { betaFeatures, handleBetaFeatureToggle } = useSettings();
  const { subscription } = useAuth();
  const [isBetaFeatureDisabled, setIsBetaFeatureDisabled] = useState(true);

  useEffect(() => {
    if (subscription?.plan === 'ultimate') {
      setIsBetaFeatureDisabled(false);
    }
  }, [subscription]);

  return (
    <>
      {betaFeaturesListings.length > 0 ? (
        betaFeaturesListings.map((feature) => (
          <div key={feature.id} className="settings-item">
            <div className="settings-item-header">
              <div className="settings-item-header-left">
                {feature.icon && <feature.icon className="settings-item-icon" />}
                <h3>
                  {feature.title}
                </h3>
              </div>
              <SwitchToggle
                isChecked={betaFeatures[feature.id]}
                setIsChecked={() => handleBetaFeatureToggle(feature.id)}
              />
            </div>
            <p className="beta-feature-description">{feature.description}</p>
            {feature.subtext && <p className="beta-feature-subtext">{feature.subtext}</p>}
            {isBetaFeatureDisabled && (
              <Link to="/pricing" className="beta-features-upgrade-link">
                Upgrade to Ultimate to{' '}
                {feature.id === 'searchConversations'
                  ? 'enjoy exclusive beta features'
                  : 'access beta features'}
                {' →'}
              </Link>
            )}
          </div>
        ))
      ) : (
        <div className="beta-features-empty">
          <p>No Beta Features available right now</p>
        </div>
      )}

      <div className="beta-disclaimer">
        <p>
          Beta features are new and still being tested. We'd love your feedback as we improve them!
        </p>
      </div>
    </>
  );
}; 